import React from 'react';
import Panel from './Panel';
import useGlobal from '../../store';
import PersonBox from '../Shoppinglist/PersonBox';
import EmptyShoppingList from '../General/EmptyShoppingList';
import { groupShoppingListByRecipient } from '../../services/shoppingList';

const ShoppingList = (props) => {
    const [panel, uiActions] = useGlobal(
        state => state.ui.sidepanel,
        actions => actions.uiActions
    );

    const [shoppinglist] = useGlobal(
        state => state.shoppinglist
    );

    const closePanel = () => {
        uiActions.closeSidePanel();
    }

    const shoppinglistPeople = groupShoppingListByRecipient(shoppinglist);
    const shoppinglistBoxes = shoppinglistPeople.map(sp => (
        <PersonBox key={String(sp.userID == null ? '' : sp.userID) + '-' + sp.FirstName} {...sp}></PersonBox>
    ));

    return (
        <Panel open={props.open && panel.name === "shoppinglist"}>
            {props.name === "shoppinglist" ?
                <>
                <div className="kt-offcanvas-panel__nav bg-white" kt-hidden-height="77">
                    <h3>Shopping List</h3>
                    <button className="kt-offcanvas-panel__close" id="kt_quick_panel_close_btn" onClick={() => closePanel()}><i className="flaticon2-delete"></i></button>
                </div>
                <div className="kt-offcanvas-panel__body">
                    <div className="tab-content">
                        <div className="tab-pane fade show kt-offcanvas-panel__content kt-scroll active ps ps--active-y" id="kt_quick_panel_tab_notifications" role="tabpanel" >
                            {shoppinglistBoxes.length > 0 ? <></> : <EmptyShoppingList></EmptyShoppingList>}
                            {shoppinglistBoxes}
                        </div>
                    </div>
                </div>
                </> : <></>}
        </Panel>

    );
}

export default ShoppingList;